
{
  "loading": "載入中...",
  "login": {
    "title": "登入",
    "description": "歡迎回來！請登入您的帳戶",
    "email": "電子郵件",
    "emailPlaceholder": "輸入您的電子郵件",
    "password": "密碼",
    "passwordPlaceholder": "輸入您的密碼",
    "submit": "登入",
    "loginButton": "登入",
    "loggingIn": "登入中...",
    "forgotPassword": "忘記密碼？"
  },
  "signup": {
    "title": "註冊",
    "description": "創建您的帳戶以開始使用",
    "firstName": "名字",
    "firstNamePlaceholder": "輸入您的名字",
    "lastName": "姓氏",
    "lastNamePlaceholder": "輸入您的姓氏",
    "name": "全名",
    "namePlaceholder": "輸入您的全名",
    "email": "電子郵件",
    "emailPlaceholder": "輸入您的電子郵件",
    "password": "密碼",
    "passwordPlaceholder": "輸入您的密碼",
    "confirmPassword": "確認密碼",
    "confirmPasswordPlaceholder": "確認您的密碼",
    "submit": "創建帳戶",
    "signupButton": "創建帳戶",
    "createAccountButton": "創建帳戶",
    "signingUp": "創建帳戶中...",
    "creatingAccount": "創建帳戶中...",
    "terms": "我同意服務條款和隐私政策"
  },
  "forgotPassword": {
    "title": "重設密碼",
    "description": "輸入您的電子郵件以接收密碼重設連結",
    "email": "電子郵件",
    "emailPlaceholder": "輸入您的電子郵件",
    "submit": "發送重設連結",
    "sendResetButton": "發送重設連結",
    "sendingReset": "發送重設連結中...",
    "success": "密碼重設連結已發送到您的電子郵件",
    "error": "發送重設連結失敗",
    "backToLogin": "返回登入"
  },
  "resetPassword": {
    "title": "設定新密碼",
    "description": "輸入您的新密碼",
    "password": "新密碼",
    "passwordPlaceholder": "輸入新密碼",
    "confirmPassword": "確認新密碼",
    "confirmPasswordPlaceholder": "確認新密碼",
    "submit": "更新密碼",
    "resetButton": "更新密碼",
    "resetting": "更新密碼中...",
    "success": "密碼已成功更新",
    "error": "更新密碼失敗",
    "updatingPassword": "更新密碼中...",
    "updatePasswordButton": "更新密碼",
    "backToLogin": "返回登入"
  },
  "socialAuth": {
    "orDivider": "或透過以下方式繼續",
    "continueWithGoogle": "使用 Google 繼續"
  },
  "validation": {
    "emailRequired": "電子郵件為必填",
    "emailInvalid": "請輸入有效的電子郵件地址",
    "passwordRequired": "密碼為必填",
    "passwordTooShort": "密碼必須至少6個字符",
    "passwordMinLength": "密碼必須至少6個字符",
    "passwordsDoNotMatch": "密碼不匹配",
    "nameRequired": "姓名為必填",
    "firstNameRequired": "名字為必填",
    "lastNameRequired": "姓氏為必填"
  },
  "languageNote": "請注意：所有列表和通信主要使用英文和繁體中文。"
}
